// src/pages/yachts/special-offers/redux/_reducer.js
import {
    FETCH_INIT_SPECIAL_OFFERS,
    FETCH_SPECIAL_OFFERS,
    FETCH_SPECIAL_OFFERS_SUCCESS,
    FETCH_SPECIAL_OFFER,
    FETCH_SPECIAL_OFFER_SUCCESS,
    CREATE_SPECIAL_OFFER,
    CREATE_SPECIAL_OFFER_SUCCESS,
    UPDATE_SPECIAL_OFFER,
    UPDATE_SPECIAL_OFFER_SUCCESS,
    ARCHIVE_SPECIAL_OFFER_SUCCESS,
    FETCH_OFFER_YACHT_RATES_SUCCESS,
    FETCH_OFFER_YACHT_SEASONS_SUCCESS
} from './_types';

const INITIAL_STATE = {
    yacht_id: null,
    offers: [],
    current: null,
    rates: [],
    seasons: [],
    loading: false,
    saving: false
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_INIT_SPECIAL_OFFERS:
            return INITIAL_STATE;
        case FETCH_SPECIAL_OFFERS:
        case FETCH_SPECIAL_OFFER:
            return { ...state, loading: true };
        case FETCH_SPECIAL_OFFERS_SUCCESS:
            return {
                ...state,
                loading: false,
                yacht_id: action.payload.yacht_id,
                offers: action.payload.offers || []
            };
        case FETCH_SPECIAL_OFFER_SUCCESS:
            return { ...state, loading: false, current: action.payload };
        case CREATE_SPECIAL_OFFER:
        case UPDATE_SPECIAL_OFFER:
            return { ...state, saving: true };
        case CREATE_SPECIAL_OFFER_SUCCESS:
            return {
                ...state,
                saving: false,
                offers: [...state.offers, action.payload],
                current: action.payload
            };
        case UPDATE_SPECIAL_OFFER_SUCCESS:
            return {
                ...state,
                saving: false,
                current: action.payload,
                offers: state.offers.map((o) =>
                    o.id === action.payload.id ? action.payload : o
                )
            };
        case ARCHIVE_SPECIAL_OFFER_SUCCESS:
            return {
                ...state,
                offers: state.offers.filter(
                    (o) => o.id !== action.payload.id
                )
            };
        case FETCH_OFFER_YACHT_RATES_SUCCESS:
            return { ...state, rates: action.payload.rates || [] };
        case FETCH_OFFER_YACHT_SEASONS_SUCCESS:
            return { ...state, seasons: action.payload.seasons || [] };
        default:
            return state;
    }
};

export default reducer;
